// extracted by mini-css-extract-plugin
module.exports = {"gettingStartedContainer":"GettingStarted_gettingStartedContainer__197fh","gettingStarted":"GettingStarted_gettingStarted__2FBWJ"};